module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-1",
    attrs: {
      "id": "untitled-1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-111"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-229-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "no-style-override2"
  }, [_vm._v("Other Books By Kevin Sullivan")])]), _vm._v(" "), _c('h3', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "sgc-2"
  }, [_c('br')])]), _vm._v(" "), _c('h3', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "sgc-2"
  }, [_c('br')])]), _vm._v(" "), _c('h3', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "sgc-3"
  }, [_vm._v("The Bundy Secrets: Hidden Files on America’s Worst Serial Killer")])]), _vm._v(" "), _c('h3', {
    staticClass: "normal-229-0-override"
  }, [_c('a', {
    attrs: {
      "href": "http://wbp.bz/bundysecrets",
      "target": "_blank"
    }
  }, [_vm._v("wbp.bz/bundysecrets")]), _c('br')]), _vm._v(" "), _c('h3', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "sgc-2"
  }, [_c('br')])]), _vm._v(" "), _c('h3', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "sgc-2"
  }, [_c('br')])]), _vm._v(" "), _c('h3', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "sgc-3"
  }, [_vm._v("Kentucky Bloodbath")])]), _vm._v(" "), _c('h3', {
    staticClass: "normal-229-0-override"
  }, [_c('a', {
    attrs: {
      "href": "http://wbp.bz/kb",
      "target": "_blank"
    }
  }, [_vm._v("wbp.bz/kb")]), _c('br')]), _vm._v(" "), _c('h3', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "sgc-2"
  }, [_c('br')])]), _vm._v(" "), _c('h3', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "sgc-2"
  }, [_c('br')])]), _vm._v(" "), _c('h3', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "sgc-3"
  }, [_vm._v("VAMPIRE: The Richard Chase Murders")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override"
  }), _vm._v(" "), _c('h3', {
    staticClass: "normal-229-0-override"
  }, [_c('a', {
    attrs: {
      "href": "http://wbp.bz/vampire",
      "target": "_blank"
    }
  }, [_vm._v("wbp.bz/vampire")]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-4"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6245512c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/otherbooksby.vue
// module id = 69
// module chunks = 0